import styled from "styled-components"

export const TimerContainer = styled.div`
    color: white;
    
    font-size: 5rem;
    justify-content: center;
    align-items: center;
    display: flex;
    box-shadow: rgba(0, 0, 0, 0.5) 20px 20px 50px;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 20px;

    @media screen and (max-width:1312px){
        font-size: 7vh;
        width: 100%;
    }
` 